import React from 'react';
import MediaQueryUtility from '@utils/MediaQueryUtility';
import { ErrorImageConvertUtility } from '@utils/ErrorImageConvertUtility';
import ErrorImage from '@components/common/ErrorImage';
import { MediaQueryUtilityClass } from '@/types/utils/MediaQueryUtilityClass';

type ImageProps = {
  id: string;
  image_url: {
    '2xl': string;
    lg: string;
    md: string;
    original: string;
    sm: string;
    xl: string;
    xs: string;
  };
  title: string;
  sort_id: number;
  image_branch_id: number;
  is_main: number;
  is_deleted: number;
  image_table_name: string;
  created_at: string;
  updated_at: string;
};

type ImagePathProps = {
  mansionName: string;
  images: ImageProps[];
};

export default function SingleImage(props: ImagePathProps): React.JSX.Element {
  const { mansionName, images } = props;
  const mediaQueryUtility: MediaQueryUtilityClass = MediaQueryUtility;

  let altText = mansionName;
  if (images[0].title) {
    altText = images[0].title;
  }
  return (
    <section className="py-3 max-md:py-2 rounded">
      <picture>
        <source media={mediaQueryUtility.getMediaQuery('sp', '@3x')} srcSet={images[0].image_url['2xl']} />
        <source media={mediaQueryUtility.getMediaQuery('sp', '@2x')} srcSet={images[0].image_url.xl} />
        <source media={mediaQueryUtility.getMediaQuery('sp')} srcSet={images[0].image_url.md} />
        <source media={mediaQueryUtility.getMediaQuery('pc', '@3x')} srcSet={images[0].image_url['2xl']} />
        <source media={mediaQueryUtility.getMediaQuery('pc', '@2x')} srcSet={images[0].image_url.xl} />
        <source media={mediaQueryUtility.getMediaQuery('pc')} srcSet={images[0].image_url.lg} />

        <ErrorImage
          alt={altText}
          className="md:max-w-7xl w-full mx-auto max-h-96 max-md:max-h-80 md:px-24 aspect-video object-contain"
          width={110}
          height={38}
          onError={(event: React.SyntheticEvent<HTMLImageElement>) => {
            ErrorImageConvertUtility.convertErrorImage(event.currentTarget);
          }}
        />
      </picture>
    </section>
  );
}
